import App from './components/store-locator/App.vue';
import { createApp } from 'vue';

function initStoreLocator() {
    const elements = document.querySelectorAll('.store-locator');

    if (!elements.length) {
        return;
    }

    const mount = (el) => createApp(App).mount(el);

    // Fallback: sem IntersectionObserver, monta imediatamente.
    if (!('IntersectionObserver' in window)) {
        elements.forEach(mount);
        return;
    }

    // O store locator fica abaixo da dobra na home. Montar o app Vue só quando
    // ele se aproxima da viewport tira o custo de bootstrap (createApp/mount) do
    // carregamento inicial, reduzindo o Total Blocking Time. Se já estiver visível
    // no load, o observer dispara na hora.
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                mount(entry.target);
                obs.unobserve(entry.target);
            }
        });
    }, { rootMargin: '200px' });

    elements.forEach((el) => observer.observe(el));
}

if (document.readyState === 'loading') {
    window.addEventListener('DOMContentLoaded', initStoreLocator);
} else {
    initStoreLocator();
}
